import { Navigate, RouteObject } from 'react-router-dom';

import { DASHBOARD, ERROR, HOME } from '@constants/routes';
import AuthRoutes from '@features/authentication/routes';
import HomeworkRoutes from '@features/homeworks/routes';
import NotificationRoutes from '@features/notification/routes';
import MainLayoutWrapper from '@contexts/MainLayoutWrapper';
import SettingsRoutes from '@features/settings/routes';
import ErrorPage from '@features/error/pages/error-page/ErrorPage';
import LeaderboardRoutes from '@features/leaderboard/routes';
import DashboardRoutes from '@features/dashboard/routes';
import NoticeboardRoutes from '@features/noticeboard/routes';
import ChatRoutes from '@features/chat/routes';
import CalendarRoutes from '@features/calendar/routes';
import QuestionPreview from '@features/homeworks/pages/question-preview';

const Routes: RouteObject[] = [
  AuthRoutes,
  {
    path: HOME.HOME,
    element: <Navigate to={DASHBOARD.DASHBOARD} /> // Re-route from '/' to '/homeworks'
  },
  {
    path: '/question-preview/:questionId',
    element: <QuestionPreview />
  },
  {
    element: <MainLayoutWrapper />, // Outlet in MainLayout will be replaced by matching element from below
    children: [
      ...HomeworkRoutes,
      ...NotificationRoutes,
      ...SettingsRoutes,
      ...LeaderboardRoutes,
      ...DashboardRoutes,
      ...NoticeboardRoutes,
      ...ChatRoutes,
      ...CalendarRoutes
    ]
  },
  {
    path: ERROR.ERROR,
    element: <ErrorPage />
  },
  {
    path: '*',
    element: <Navigate to="/error/404" />
  }
];

export default Routes;
